// src/api.js
import axios from "axios";
import { getFreshToken } from "./utils/authToken";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

/* ---------- request interceptor ---------- */
api.interceptors.request.use(async (cfg) => {
  const token = await getFreshToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

/* ---------- response interceptor ---------- */
api.interceptors.response.use(
  (r) => r,                                        // OK ✨
  async (error) => {
    // Sólo reintenta una vez si fue 401
    const conf = error.config;
    if (error.response?.status === 401 && !conf._retry) {
      conf._retry = true;
      const token = await getFreshToken();         // fuerza actualización
      if (token) conf.headers.Authorization = `Bearer ${token}`;
      return api(conf);                            // → re-intentamos
    }
    return Promise.reject(error);
  }
);

export default api;
